import React from "react";
import { Link } from "react-router-dom";
import "./pnf.scss";
import CustomButton from "../shared/custom-button/custom-button";
import { NavLink } from "react-router-dom";

const PNF = () => {
  return (
    <div className="pnf-container" id="pnf-page">
      {/* Background large 404 text image */}
      <div className="pnf-bg-text">
        <img src="/images/pnf/404-bg.webp" alt="404 Background" />
      </div>

      <div className="pnf-content">
        {/* Central 404 graphic card */}
        <div className="pnf-card">
          <img src="/images/pnf/404-img.webp" alt="404 Illustration" />
        </div>

        {/* Textual content */}
        <h1 className="pnf-title">Opps! Page Not Found</h1>
        <p className="pnf-description">
          The page you’re looking for may have been moved, renamed, or is no
          longer available. Our work is focused on clarity and structure — let's
          help you get back to the right place.
        </p>

        {/* Call to action */}
        <CustomButton as={NavLink} to={"/"}>
          Back to Homepage
        </CustomButton>
      </div>
    </div>
  );
};

export default PNF;
